const SEL = {
  postNav: `cc-post-navigation`,
  toggler: `__toggler`,
  postNavList: `__list`,
  itemWithToggler: `__contains-toggler`,
  itemWithTogglerTop: `__headline`,
  classActive: 'active',
  classVisible: 'visibility-on',
  classAccordionOn: 'cc-accordion',
  accordionForced: false,
  togglerTopIndex: null,
  togglerStatePreserved: '_toggler-preserved',
};
SEL.accordionForced = checkAccordionIsForced();

const togglers = document.querySelectorAll( `.${ SEL.postNav + SEL.toggler }` );
for ( let i = 0; i < togglers.length; i++ ) {
  togglers[ i ].addEventListener( 'click', function( e ) {
    e.preventDefault();
    e.target.classList.toggle( SEL.classActive );
    const menu = e.target.closest( `.${ SEL.postNav + SEL.itemWithToggler }` ).nextElementSibling;
    if ( menu ) {
      menu.classList.toggle( SEL.classVisible );
    }

    // on expand collapse other opened items but not in case of top level toggler click
    if ( i !== SEL.togglerTopIndex && e.target.classList.contains( SEL.classActive ) ) {
      closeOtherLists( e.target );
    }
  } );

  // save top item' index to trigger click on it later on.
  // see collapseMobileAccordion() and expandMobileAccordion()
  if ( togglers[ i ].closest( `.${ SEL.postNav + SEL.itemWithTogglerTop }` ) ) {
    SEL.togglerTopIndex = i;
  }
}

/**
 *
 * @param {string} propertyName name of property needed for transition
 * @return {string} value of media query, that we need to switch
 */
function getTransitionPoint( propertyName ) {
  return window.getComputedStyle( document.body ).getPropertyValue( propertyName ) || '768px';
}
const mQueryMobilePoint = getTransitionPoint( '--cvle-pr-area-nav-mobile-point' );

const domElements = document.querySelectorAll(
  `.${ SEL.postNav + SEL.postNavList },
  .${ SEL.postNav + SEL.toggler }
  `
);

const mediaQueryValue = `only screen and (max-width: ${ mQueryMobilePoint })`;
const mediaQuery = window.matchMedia( mediaQueryValue );
mediaQuery.addEventListener( 'change', ( event ) => {
  handleClassChange( event, SEL.classAccordionOn );
  accordionTopLevelToggle( event );
} );
handleClassChange( mediaQuery, SEL.classAccordionOn );
accordionTopLevelToggle( mediaQuery );

/**
 *
 * @param { Object } mediaQueryList object to watch media query changes
 * @param { string } className      name of the class to pass it further to classChanger;
 *                                  function exists to loop through all elements, to change class
 */
function handleClassChange( mediaQueryList, className ) {
  domElements.forEach( ( domElement ) => classChanger( mediaQueryList, className, domElement ) );
}

/**
 *
 * @param { Object } mediaQueryList object to watch media query changes
 * @param { string } className      name of the class to add/remove, when media query changes
 * @param {Object}   domElement     domElemet
 */
function classChanger( mediaQueryList, className, domElement ) {
  if ( SEL.accordionForced ) {
    domElement.classList.add( className );
    return;
  }

  if ( mediaQueryList.matches ) {
    domElement.classList.add( className );
  } else {
    domElement.classList.remove( className );
  }
}

/**
 * collapse on mobile and expand on tablet/desktop accordion' top level item
 * @param { Object } mediaQueryList object to watch media query changes
 */
function accordionTopLevelToggle( mediaQueryList ) {
  const item = togglers[ SEL.togglerTopIndex ];
  const itemIsOpened = item.classList.contains( SEL.classActive );

  if (
    // collapse if on mobile and item expanded
    ( mediaQueryList.matches && itemIsOpened ) ||
    // expand if on tablet/desktop and item collapsed
    ( ! mediaQueryList.matches && ! itemIsOpened )
  ) {
    item.click();
  }
}

/**
 * Check if navigation object has accordion_forced data attr making it
 * to behave as accordion regardless of device type
 * @return {boolean} true if shortcode attribute accordion_forced was set as True
 */
function checkAccordionIsForced() {
  const obj = document.querySelector( `.${ SEL.postNav }` );
  return obj && obj.dataset.accordionForced === '1';
}

/**
 * Closes all opened submenus except those relevant to the clicked toggler
 * @param { Object } currentToggler toggler object that was clicked
 */
function closeOtherLists( currentToggler ) {
  saveTogglerState( currentToggler );
  toggleUnsavedTogglers();
  clearTogglersState();
}

/**
 * Recursively adds helper class to the clicked toggler and all the ancestor togglers
 * @param { Object } el toggler object that was clicked or its ancestor toggler in case of recursion call
 */
function saveTogglerState( el ) {
  el.classList.add( SEL.togglerStatePreserved );
  const parentList = el.closest( `.${ SEL.postNav + SEL.postNavList }` );
  if ( ! parentList ) {
    return;
  }
  const parentListSibling = parentList.previousElementSibling;
  if ( ! parentListSibling || ! parentListSibling.classList.contains( SEL.postNav + SEL.itemWithToggler ) ) {
    return;
  }
  const ancestorEl = parentListSibling.querySelector( `.${ SEL.postNav + SEL.toggler }` );
  if ( ancestorEl ) {
    saveTogglerState( ancestorEl );
  }
}

/**
 * Trigger all unsaved active togglers and thus closes all corresponding submenus
 */
function toggleUnsavedTogglers() {
  const unsavedTogglers = document.querySelectorAll( `.${ SEL.postNav + SEL.toggler }.${ SEL.classActive }:not(.${ SEL.togglerStatePreserved })` );
  unsavedTogglers.forEach( ( el ) => el.click() );
}

/**
 * Removes the 'saved' state of togglers after the toggler was clicked
 */
function clearTogglersState() {
  const savedTogglers = document.querySelectorAll( `.${ SEL.postNav + SEL.toggler }.${ SEL.togglerStatePreserved }` );
  savedTogglers.forEach( ( el ) => el.classList.remove( SEL.togglerStatePreserved ) );
}
